import React, { Component } from "react";
import PropTypes from 'prop-types';
import Slick from "react-slick";
import { generate } from "shortid";
import isMobile from "is-mobile";
import arrow from "../../assets/imgs/slick-arrow-grey.png";
import greenArrow from "../../assets/imgs/green-arrow.png";

import "./SwipeableViews.scss";

class SwipeableViews extends Component {
  static propTypes = {
    hasArrows: PropTypes.bool,
    hasDots: PropTypes.bool,
    isGreenArrow: PropTypes.bool,
    isInfinite: PropTypes.bool,
    isSwipeable: PropTypes.bool,
    slidesToShow: PropTypes.number,

  };

  static defaultProps = {
    hasArrows: true,
    hasDots: true,
    isGreenArrow: false,
    isInfinite: false,
    isSwipeable: true,
    slidesToShow: 1

  };

  componentDidUpdate() {
    const { index, children } = this.props;

    if (index >= 0) {
      this.goTo(index);
    }
  }

  goTo = index => {
    if (this.slick) {
      this.slick.slickGoTo(index);
    }
  };

  renderDot = dots => (
    <ul className="swipeable-views__dots">
      {dots.map((dot, index) => (
        <button
          key={generate()}
          className={`swipeable-views__dots__dot ${
            index === this.props.index
              ? "swipeable-views__dots__dot--active"
              : ""
          }`}
          onClick={() => this.goTo(index)}
        />
      ))}
    </ul>
  );

  render() {
    const { children, isSwipeable ,hasArrows, hasDots, isInfinite,isGreenArrow } = this.props;

    return (
      <Slick
        ref={slick => {
          this.slick = slick;
        }}
        className="swipeable-views__slick"
        dots={hasDots}
        swipe={isSwipeable}
        direction="horizontal"
        infinite={isInfinite}
        slidesToShow={this.props.slidesToShow}
        slidesToScroll={1}
        appendDots={dot => this.renderDot(dot)}
        beforeChange={(oldIndex, newIndex) => this.props.handleSwipe(newIndex)}
        arrows={!isMobile() && hasArrows}
        nextArrow={<img className="slick-arrow next" src={isGreenArrow ? greenArrow : arrow} alt="arrow" data-testid="swiper-next"/>}
        prevArrow={<img className="slick-arrow prev" src={isGreenArrow ? greenArrow : arrow} alt="arrow" data-testid="swiper-prev"/>}
      >
        {children}
      </Slick>
    );
  }
}

export default SwipeableViews;
